import {
  Modal,
  ModalDialog,
  ModalHeader,
  ModalTitle,
  ModalBody,
  FormGroup,
  Button,
  Loader,
} from '@ax/ui';
import { useState } from 'react';
import LightEditor from '@/components/Editor/LightEditor';
import {
  addReevaluationEnded,
  createReevaluationRequested,
  selectIsAddingNewSentence, selectReevalModalHasError,
  selectReevalSentences,
  selectSelectedVisit,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';

interface AddReEvaluationModalProps {
  modalOpen?: boolean;
}

export const AddReEvaluationModal = ({ modalOpen = false }: AddReEvaluationModalProps) => {
  const dispatch = useAppDispatch();
  const [reEvaluationContent, setReEvaluationContent] = useState('');
  const visitSelected = useAppSelector(selectSelectedVisit);
  const isAddingNewSentence = useAppSelector(selectIsAddingNewSentence);
  const progressSentences = useAppSelector(selectReevalSentences);
  const reEvaluationModalHasError = useAppSelector(selectReevalModalHasError);

  const handleModalClose = () => {
    dispatch(
      addReevaluationEnded({ noteId: visitSelected.uuid, status: 'Cancelled', withError: reEvaluationModalHasError }),
    );
  };

  const handleSaveReeval = () => {
    const order = progressSentences?.length ? progressSentences.length + 1 : 1;
    dispatch(
      createReevaluationRequested({ noteId: visitSelected.uuid, content: reEvaluationContent, order }),
    );
  };

  const handleContentChange = (content: string) => {
    setReEvaluationContent(content);
  };

  return (
    <Modal onShow={modalOpen}>
      <ModalDialog>
        <ModalHeader isCloseBtnDisabled={isAddingNewSentence} onHide={handleModalClose}>
          <ModalTitle>Add Reevaluation</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <FormGroup className="col-span-6">
            <LightEditor
              isEditable={!isAddingNewSentence}
              content={''}
              onEditorBlur={() => {}}
              minHeight={150}
              onContentChange={handleContentChange}
              autoFocus={true}
            />
          </FormGroup>

          <div className="flex gap-2">
            <Button
              className="h-[40px] mt-[10px]"
              variant="outline"
              block
              disabled={isAddingNewSentence}
              type="button"
              onClick={handleModalClose}>
              Cancel
            </Button>
            <Button
              className="h-[40px] mt-[10px]"
              variant="primary"
              block
              type="submit"
              onClick={handleSaveReeval}>
              {isAddingNewSentence ? (
                  <Loader color={'white'}/>
              ) : (
                'Add'
              )}
            </Button>
          </div>
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};
